var map = {
	"./App": 18238,
	"./App.js": 18238,
	"./Authentication/ForgotPwdForm": 74864,
	"./Authentication/ForgotPwdForm.js": 74864,
	"./Authentication/GoogleSignIn": 40713,
	"./Authentication/GoogleSignIn.js": 40713,
	"./Authentication/LoginForm": 88206,
	"./Authentication/LoginForm.js": 88206,
	"./Authentication/RegistrationForm": 78848,
	"./Authentication/RegistrationForm.js": 78848,
	"./Authentication/ResetPwdForm": 43708,
	"./Authentication/ResetPwdForm.js": 43708,
	"./Authentication/VerificationForm": 26705,
	"./Authentication/VerificationForm.js": 26705,
	"./Board/Board": 16996,
	"./Board/Board.js": 16996,
	"./Board/Card": 54217,
	"./Board/Card.js": 54217,
	"./Board/Forms/DocumentAnalyzer": 95688,
	"./Board/Forms/DocumentAnalyzer.js": 95688,
	"./Board/Forms/ExpenseProperties": 9669,
	"./Board/Forms/ExpenseProperties.js": 9669,
	"./Board/Forms/Form": 93267,
	"./Board/Forms/Form.js": 93267,
	"./Board/Forms/RevenueProperties": 27788,
	"./Board/Forms/RevenueProperties.js": 27788,
	"./Board/Forms/TaxItemsForm": 44700,
	"./Board/Forms/TaxItemsForm.js": 44700,
	"./Board/Toolbox": 35324,
	"./Board/Toolbox.js": 35324,
	"./Company/CalculationSettings": 83424,
	"./Company/CalculationSettings.js": 83424,
	"./Company/Form": 90875,
	"./Company/Form.js": 90875,
	"./Company/Settings": 69594,
	"./Company/Settings.js": 69594,
	"./Company/TaxSettings": 93437,
	"./Company/TaxSettings.js": 93437,
	"./Customers/CustomerInfo": 95639,
	"./Customers/CustomerInfo.js": 95639,
	"./Customers/Customers": 79330,
	"./Customers/Customers.js": 79330,
	"./Customers/Form": 49370,
	"./Customers/Form.js": 49370,
	"./Customers/Toolbox": 47456,
	"./Customers/Toolbox.js": 47456,
	"./Dashboard/Charts/BarChart": 32057,
	"./Dashboard/Charts/BarChart.js": 32057,
	"./Dashboard/Charts/FilledChart": 59369,
	"./Dashboard/Charts/FilledChart.js": 59369,
	"./Dashboard/Charts/TurnoverChart": 95035,
	"./Dashboard/Charts/TurnoverChart.js": 95035,
	"./Dashboard/Dashboard": 36424,
	"./Dashboard/Dashboard.js": 36424,
	"./Dashboard/Items/DeadlinesTimeline": 27456,
	"./Dashboard/Items/DeadlinesTimeline.tsx": 27456,
	"./Dashboard/Items/ReportBox": 96339,
	"./Dashboard/Items/ReportBox.js": 96339,
	"./Kanban": 18865,
	"./Kanban/": 18865,
	"./Kanban/components/Column": 53020,
	"./Kanban/components/Column/": 53020,
	"./Kanban/components/Column/components/Card": 49348,
	"./Kanban/components/Column/components/Card/": 49348,
	"./Kanban/components/Column/components/Card/index": 49348,
	"./Kanban/components/Column/components/Card/index.js": 49348,
	"./Kanban/components/Column/components/CardAdder": 56706,
	"./Kanban/components/Column/components/CardAdder/": 56706,
	"./Kanban/components/Column/components/CardAdder/components/CardForm": 7402,
	"./Kanban/components/Column/components/CardAdder/components/CardForm/": 7402,
	"./Kanban/components/Column/components/CardAdder/components/CardForm/index": 7402,
	"./Kanban/components/Column/components/CardAdder/components/CardForm/index.js": 7402,
	"./Kanban/components/Column/components/CardAdder/components/CardForm/index.spec": 29275,
	"./Kanban/components/Column/components/CardAdder/components/CardForm/index.spec.js": 29275,
	"./Kanban/components/Column/components/CardAdder/index": 56706,
	"./Kanban/components/Column/components/CardAdder/index.js": 56706,
	"./Kanban/components/Column/index": 53020,
	"./Kanban/components/Column/index.js": 53020,
	"./Kanban/components/ColumnAdder": 72987,
	"./Kanban/components/ColumnAdder/": 72987,
	"./Kanban/components/ColumnAdder/components/ColumnForm": 70413,
	"./Kanban/components/ColumnAdder/components/ColumnForm/": 70413,
	"./Kanban/components/ColumnAdder/components/ColumnForm/index": 70413,
	"./Kanban/components/ColumnAdder/components/ColumnForm/index.js": 70413,
	"./Kanban/components/ColumnAdder/index": 72987,
	"./Kanban/components/ColumnAdder/index.js": 72987,
	"./Kanban/components/DefaultCard": 22288,
	"./Kanban/components/DefaultCard/": 22288,
	"./Kanban/components/DefaultCard/index": 22288,
	"./Kanban/components/DefaultCard/index.js": 22288,
	"./Kanban/components/DefaultColumnHeader": 62246,
	"./Kanban/components/DefaultColumnHeader/": 62246,
	"./Kanban/components/DefaultColumnHeader/index": 62246,
	"./Kanban/components/DefaultColumnHeader/index.js": 62246,
	"./Kanban/index": 18865,
	"./Kanban/index.js": 18865,
	"./Kanban/services": 56834,
	"./Kanban/services/": 56834,
	"./Kanban/services/helpers": 26159,
	"./Kanban/services/helpers.js": 26159,
	"./Kanban/services/index": 56834,
	"./Kanban/services/index.js": 56834,
	"./Kanban/services/utils": 10517,
	"./Kanban/services/utils.js": 10517,
	"./Kanban/withDroppable": 66742,
	"./Kanban/withDroppable/": 66742,
	"./Kanban/withDroppable/index": 66742,
	"./Kanban/withDroppable/index.js": 66742,
	"./Landingpages/AT/Main": 19150,
	"./Landingpages/AT/Main.js": 19150,
	"./Landingpages/Landingpage": 31843,
	"./Landingpages/Landingpage.js": 31843,
	"./Layouts/InfoLayout": 19250,
	"./Layouts/InfoLayout.js": 19250,
	"./Layouts/Layout": 77425,
	"./Layouts/Layout.js": 77425,
	"./Legal/Privacy": 62556,
	"./Legal/Privacy.js": 62556,
	"./Legal/Terms": 5606,
	"./Legal/Terms.js": 5606,
	"./Onboarding/OnboardingSteps": 38200,
	"./Onboarding/OnboardingSteps.js": 38200,
	"./Onboarding/Preboarding": 53711,
	"./Onboarding/Preboarding.js": 53711,
	"./Reports/Report": 83360,
	"./Reports/Report.js": 83360,
	"./Settings/Pricing": 55691,
	"./Settings/Pricing.js": 55691,
	"./Settings/Settings": 40774,
	"./Settings/Settings.js": 40774,
	"./Shared/Avatar": 46269,
	"./Shared/Avatar.js": 46269,
	"./Shared/Filters": 46412,
	"./Shared/Filters.js": 46412,
	"./Shared/FormItems": 29526,
	"./Shared/FormItems.js": 29526,
	"./Shared/Logo": 73396,
	"./Shared/Logo.js": 73396,
	"./Shared/MoreMenu": 24883,
	"./Shared/MoreMenu.js": 24883,
	"./Shared/OrDivider": 90015,
	"./Shared/OrDivider.js": 90015,
	"./Shared/Paginator": 40034,
	"./Shared/Paginator.js": 40034,
	"./Shared/PricingBoxes": 18504,
	"./Shared/PricingBoxes.js": 18504,
	"./Shared/Sidebar": 86445,
	"./Shared/Sidebar.js": 86445,
	"./Shared/Toolbox": 4689,
	"./Shared/Toolbox.js": 4689,
	"./Shared/Topbar": 26441,
	"./Shared/Topbar.js": 26441,
	"./Shared/UserMenu": 97098,
	"./Shared/UserMenu.js": 97098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 982;